import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
		
	return (
		<div className="c-cover">
			<div className="c-cover__logo">
				<div
					to="/" 
					className="c-cover__logo__inner" 
					dangerouslySetInnerHTML={{
						__html: '<svg width="100" height="21" viewBox="0 0 100 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0V2.46971H8.50819V20.1108H11.215V2.46971H19.6646V0H0Z" fill="black"/><path d="M21.7891 0V20.1108H38.1807V17.6411H24.4959V11.2903H36.8712V8.82057H24.4959V2.49903H37.8836V0H21.7891Z" fill="black"/><path d="M56.6644 0V16.5408H56.4552L43.7816 0H40.3008V20.1108H43.0089V3.54072H43.2167L55.8904 20.1108H59.3712V0H56.6644Z" fill="black"/><path d="M61.4922 0V20.1108H77.8838V17.6411H64.199V11.2903H76.5744V8.82057H64.199V2.49903H77.5855V0H61.4922Z" fill="black"/><path d="M79.7539 0V2.46971H88.2634V20.1108H90.9702V2.46971H99.4185V0H79.7539Z" fill="black"/></svg>'
					}}
				/>
			</div>
		</div>
	)
	
}
export default WithConsumer(Cover);